export enum SalesKpiTimeRange {
  THIS_WEEK = 'this_week',
  LAST_WEEK = 'last_week',
  LAST_WEEKS = 'last_weeks',
  YTD = 'ytd',
}

export interface SalesKpiOptions {
  range?: SalesKpiTimeRange;
  weeks?: number;
}

export interface SalesKpis {
  totalQuantity: number;
  previousTotalQuantity: number;
  changePercent: number | null;
  range: SalesKpiTimeRange;
  weeks: number | null;
}
